module.exports = __webpack_public_path__ + "img/desc4.aadca657.jpg";